import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './UserBadge.module.scss';

export enum BadgeColor {
  Primary = 'primary',
  Dark = 'dark',
}

export enum BadgeSize {
  Big = 'big',
  Small = 'small',
}

interface Props {
  name: string;
  className?: string;
  onClick?: () => void;
  color?: BadgeColor;
  size?: BadgeSize;
}

function getInitials(name: string) {
  const names = name.split(' ');
  return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`;
}

export const UserBadge: FC<Props> = (props) => {
  const { name, className, onClick, color, size } = props;
  return (
    <div
      data-size={size ?? BadgeSize.Big}
      data-color={color ?? BadgeColor.Dark}
      onClick={onClick}
      className={clsx(styles.container, className)}
    >
      {getInitials(name)}
    </div>
  );
};
